var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBarchartUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.39 56.35H8.11001V46.66H13.39V56.35ZM14.45 44.5H7.06001C6.42001 44.5 6.00001 44.93 6.00001 45.58V57.43C6.00001 58.08 6.42001 58.51 7.06001 58.51H14.45C15.08 58.51 15.51 58.08 15.51 57.43V45.58C15.51 44.93 15.09 44.5 14.45 44.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.78 56.31H22.22V37.69H27.78V56.31ZM28.89 35.5H21.11C20.44 35.5 20 35.94 20 36.6V57.41C20 58.07 20.44 58.51 21.11 58.51H28.89C29.56 58.51 30 58.07 30 57.41V36.6C30 35.94 29.56 35.5 28.89 35.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.28 56.33H36.72V29.17H42.28V56.33ZM43.39 27H35.61C34.94 27 34.5 27.43 34.5 28.09V57.42C34.5 58.07 34.94 58.51 35.61 58.51H43.39C44.06 58.51 44.5 58.08 44.5 57.42V28.09C44.5 27.44 44.06 27 43.39 27Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.28 56.31H50.72V20.19H56.28V56.31ZM57.39 18H49.61C48.94 18 48.5 18.44 48.5 19.09V57.4C48.5 58.06 48.94 58.49 49.61 58.49H57.39C58.06 58.49 58.5 58.05 58.5 57.4V19.09C58.5 18.43 58.06 18 57.39 18Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.21 8.63L35.68 6.02C35.13 5.91 34.48 6.24 34.37 6.78C34.26 7.32 34.59 7.98 35.14 8.08L42.15 10.04L6.54001 30.37C5.99001 30.7 5.88001 31.35 6.10001 31.89C6.54001 32.54 6.98001 32.65 7.63001 32.32L43.23 11.89L41.37 18.85C41.26 19.39 41.59 20.05 42.14 20.15C42.8 20.26 43.24 19.93 43.45 19.39L45.97 9.93C46.08 9.17 45.86 8.84 45.2 8.63H45.21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarchartUp);
export default __webpack_public_path__ + "static/media/icon-barchart-up.a3a1fbf7014c20997426b2f7f7cadfcd.svg";
export { ForwardRef as ReactComponent };